import React from 'react';
import PropTypes from 'prop-types';
import { ScanBodyHeader } from './body-header';
import { TitleBox } from './layout/title-box';

export const ScanBody = ({ shipmentNumber, renderBody }) => (
  <TitleBox renderBody={renderBody} renderTitle={() => <ScanBodyHeader shipmentNumber={shipmentNumber} />} />
);

ScanBody.propTypes = {
  shipmentNumber: PropTypes.string,
  renderBody: PropTypes.func.isRequired,
};
